module.exports = __webpack_public_path__ + "img/house_25.52719c6b.jpg";